import { GroupType } from 'src/features/Customers/Details/Groups/types';
import { HallsType } from 'src/features/Customers/Details/Hall/types';
import {
  LIST_CUSTOMER_HALLS,
  LIST_CUSTOMER_GROUPS,
} from '../actions/customerHallsActions';

export type CustomerHallsReducerActionType = {
  type: string;
  payload: {
    halls: HallsType;
    groups: Array<GroupType>;
    items: any;
    total: number;
  };
};

const defaultState = {
  items: [],
  groups: {},
  total: 0,
};

const customerHallsReducer = (
  state = defaultState,
  action: CustomerHallsReducerActionType
) => {
  switch (action.type) {
    case LIST_CUSTOMER_HALLS:
      return { ...state, halls: action.payload };
    case LIST_CUSTOMER_GROUPS:
      return { ...state, groups: action.payload.items };
    default:
      return state;
  }
};

export default customerHallsReducer;
